import { FC } from 'react';

import { Grid } from '@mui/material';
import { isEmpty } from 'lodash';

import { IGanttChartMobileProps as IProps } from './types';
import { GANTT_CHART_STATUSES } from '../../types';
import { GanttChartMobileCard } from '../GanttChartMobileCard';

import styles from './GanttChartMobile.module.scss';

export const GanttChartMobile: FC<IProps> = ({
  doneChartData,
  inProgressChartData,
  toDoChartData,
  variant,
  MobileCardWrapper,
}) => {
  return (
    <Grid container className={styles.wrapper} gap="16px">
      {!isEmpty(doneChartData) && (
        <Grid item xs={12}>
          <GanttChartMobileCard
            MobileCardWrapper={MobileCardWrapper}
            status={GANTT_CHART_STATUSES.DONE}
            chartData={doneChartData}
            variant={variant}
          />
        </Grid>
      )}
      {!isEmpty(inProgressChartData) && (
        <Grid item xs={12}>
          <GanttChartMobileCard
            MobileCardWrapper={MobileCardWrapper}
            status={GANTT_CHART_STATUSES.IN_PROGRESS}
            chartData={inProgressChartData}
            variant={variant}
          />
        </Grid>
      )}
      {!isEmpty(toDoChartData) && (
        <Grid item xs={12}>
          <GanttChartMobileCard
            MobileCardWrapper={MobileCardWrapper}
            status={GANTT_CHART_STATUSES.TO_DO}
            chartData={toDoChartData}
            variant={variant}
          />
        </Grid>
      )}
    </Grid>
  );
};
